<div class="flex flex-col items-center justify-center max-w-md mx-auto w-full">
    <div class="inputs w-full flex flex-col gap-3" (keydown.enter)="onSubmit()">
        <div class="flex flex-col mb-4 w-full">
            <div class="text-white mb-2">
                <p class="text-white antialiased">Unlock Superior Discounts</p>
            </div>

            <div class="relative flex flex-col w-full">
                <input id="phoneInput" class="input p-3 rounded-lg w-full focus:ring-2 focus:ring-primary border-1
            transition-all placeholder-gray-400 text-white" type="tel" placeholder="Enter Mobile Number"
                    [(ngModel)]="phoneNumber" (input)="formatPhoneNumber()" #phone="ngModel" pattern="[0-9]{5}-[0-9]{5}"
                    required />

                <div *ngIf="phone.invalid && (phone.dirty || phone.touched)"
                    class="text-red-300 font-bold text-sm mt-1">
                    <div *ngIf="phone.errors?.['required']">Phone number is required</div>
                    <div *ngIf="phone.errors?.['pattern']">Please enter a valid 10-digit number</div>
                </div>
            </div>

            <div *ngIf="noAccountFound" class="text-white text-sm mt-1">
                <p>No Account Registered with this number</p>
            </div>

            <div class="flex items-center mt-3">
                <input type="checkbox" id="whatsappConsent"
                    class="custom-checkbox h-4 w-4 focus:ring-primary rounded"
                    [(ngModel)]="whatsappConsent" />
                <label for="whatsappConsent" class="ml-2 text-sm text-white">
                    Notify me for any updates & offers
                </label>
            </div>

            <button (click)="onSubmit()"
                class="w-full rounded-lg p-3 my-4 font-medium btn-secondary text-white flex items-center justify-center gap-2"
                [disabled]="phone.invalid"> Login
            </button>

            <div class="text-xs text-white mt-4 text-center">
                I accept that I have read & understood Mashhoorplus's <a routerLink="/privacy-policy"
                    class="cursor-pointer text-secondary">Privacy Policy</a> and T&Cs.
            </div>
        </div>
    </div>
</div>

<!-- <span class="text-green-700">
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
      <path d="M17.6 6.32C16.55 5.82 15.45 5.5 14.3 5.5C9.55 5.5 5.7 9.35 5.7 14.1C5.7 15.65 6.15 17.15 6.95 18.5L5.67 23L10.28 21.75C11.55 22.5 12.8 22.9 14.25 22.9H14.3C19.05 22.9 22.5 19.05 22.5 14.3C22.5 12.95 21.93 11.7 21.15 10.67C20.28 9.53 19 8.42 17.6 6.32M14.3 21.3C13.05 21.3 11.8 20.95 10.75 20.3L10.5 20.15L7.85 20.8L8.5 18.25L8.35 17.95C7.65 16.85 7.3 15.55 7.3 14.15C7.3 10.25 10.4 7.1 14.35 7.1C15.3 7.1 16.2 7.3 17.05 7.7C17.9 8.1 18.65 8.65 19.25 9.35C19.95 10.05 20.4 10.9 20.75 11.9C21.1 12.9 21.3 13.95 21.3 15C21.25 18.15 18.05 21.3 14.3 21.3M18.25 16.5C18.05 16.4 17.15 15.95 16.95 15.9C16.75 15.85 16.65 15.8 16.5 16C16.4 16.2 16.05 16.65 15.95 16.75C15.85 16.9 15.75 16.9 15.55 16.8C15.35 16.7 14.75 16.5 14.05 15.85C13.5 15.35 13.1 14.75 13 14.55C12.9 14.35 13 14.25 13.1 14.15C13.2 14.05 13.3 13.95 13.4 13.8C13.5 13.7 13.55 13.6 13.6 13.45C13.65 13.35 13.6 13.2 13.55 13.1C13.5 13 13.1 12.1 12.9 11.7C12.75 11.3 12.55 11.35 12.45 11.35H12.1C11.95 11.35 11.75 11.4 11.55 11.6C11.35 11.8 10.85 12.25 10.85 13.15C10.85 14.05 11.5 14.95 11.6 15.1C11.7 15.25 13.1 17.35 15.15 18.15C16.8 18.8 16.8 18.6 17.2 18.55C17.6 18.5 18.35 18.1 18.5 17.65C18.65 17.2 18.65 16.8 18.6 16.75C18.55 16.65 18.45 16.6 18.25 16.5Z"/>
    </svg>
  </span> -->